<template>
	<div class="tournament">
		<SubHeader title="ODO Tournament" subtitle="ODOトーナメント" />

		<div class="container">
			<ul class="nav nav-pills mb-3" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link" href="/tournament/2026"> 2026年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/tournament/2025"> 2025年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/tournament/2024"> 2024年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/tournament/2023"> 2023年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/tournament/2022"> 2022年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link active" href="javascript:void(0);"> 2021年度 </a>
				</li>
			</ul>

			<div class="row justify-content-center">
				<div class="col-lg-12 mb-4">
					<h2>ODO Darts Tournament 2021</h2>
					<img
						src="/images/tournament/2021/tournament2021.jpg"
						class="img-fluid"
					/>
				</div>
			</div>

			<div class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>メンズ&nbsp;シングルス</h4>
				</div>
				<div class="col-3 text-center offset-1">
					<p>
						<span class="rank_2nd"><i class="fas fa-medal"></i>2nd</span>
						<img
							src="/images/tournament/2021/result/mens_singles_2nd.jpg"
							class="img-fluid"
							@click="openGallery(1)"
						/>
						<span class="name">石井 庸介</span>
					</p>
				</div>
				<div class="col-4 text-center">
					<p>
						<span class="rank_winner"><i class="fas fa-medal"></i>Winner</span>
						<img
							src="/images/tournament/2021/result/mens_singles_winner.jpg"
							class="img-fluid"
							@click="openGallery(0)"
						/>
						<span class="name">西本 陽一</span>
					</p>
				</div>
				<div class="col-3 text-center">
					<p>
						<span class="rank_3rd"><i class="fas fa-medal"></i>3rd</span>
						<img
							src="/images/tournament/2021/result/mens_singles_3rd.jpg"
							class="img-fluid"
							@click="openGallery(2)"
						/>
						<span class="name">西巻 竜太</span>
					</p>
				</div>
			</div>

			<div class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>レディース&nbsp;シングルス</h4>
				</div>
				<div class="col-3 text-center offset-1">
					<p>
						<span class="rank_2nd"><i class="fas fa-medal"></i>2nd</span>
						<img
							src="/images/tournament/2021/result/ladies_singles_2nd.jpg"
							class="img-fluid"
							@click="openGallery(4)"
						/>
						<span class="name">青木 まゆ</span>
					</p>
				</div>
				<div class="col-4 text-center">
					<p>
						<span class="rank_winner"><i class="fas fa-medal"></i>Winner</span>
						<img
							src="/images/tournament/2021/result/ladies_singles_winner.jpg"
							class="img-fluid"
							@click="openGallery(3)"
						/>
						<span class="name">宮野 麻衣</span>
					</p>
				</div>
				<div class="col-3 text-center">
					<p>
						<span class="rank_3rd"><i class="fas fa-medal"></i>3rd</span>
						<img
							src="/images/tournament/2021/result/ladies_singles_3rd.jpg"
							class="img-fluid"
							@click="openGallery(5)"
						/>
						<span class="name">安田 久美</span>
					</p>
				</div>
			</div>

			<div class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>オープン&nbsp;ダブルス</h4>
				</div>
				<div class="col-3 text-center offset-1">
					<p>
						<span class="rank_2nd"><i class="fas fa-medal"></i>2nd</span>
						<img
							src="/images/tournament/2021/result/open_doubles_2nd.jpg"
							class="img-fluid"
							@click="openGallery(7)"
						/>
						<span class="name">谷田 孝夫（大阪）・高山 得溶（大阪）</span>
					</p>
				</div>
				<div class="col-4 text-center">
					<p>
						<span class="rank_winner"><i class="fas fa-medal"></i>Winner</span>
						<img
							src="/images/tournament/2021/result/open_doubles_winner.jpg"
							class="img-fluid"
							@click="openGallery(6)"
						/>
						<span class="name">磯和 勇希（大阪）・杉山 裕貴（一般）</span>
					</p>
				</div>
				<div class="col-3 text-center">
					<p>
						<span class="rank_3rd"><i class="fas fa-medal"></i>3rd</span>
						<img
							src="/images/tournament/2021/result/open_doubles_3rd.jpg"
							class="img-fluid"
							@click="openGallery(8)"
						/>
						<span class="name">谷田 尚嗣（大阪）・岩谷 由人（大阪）</span>
					</p>
				</div>
			</div>

			<div class="row">
				<div class="col-lg-12 mb-3">
					<h5 class="mb-4">開催情報</h5>
					<dl class="row">
						<dt class="col-sm-1">日時</dt>
						<dd class="col-sm-11">
							<span style="font-size: 1.2rem">2021年7月4日（日）</span>
							<br />
							チェックイン：9:15〜、開会式：10:00〜、競技開始：10:15〜
						</dd>
						<dt class="col-sm-1">場所</dt>
						<dd class="col-sm-11">
							<span style="font-size: 1rem"
								>公益法人 堺市産業振興センター イベントホール</span
							><br />
							〒591-8025 大阪府堺市北区長曽根町183-5<br />
							<a href="https://www.sakai-ipc.jp/" target="_blank"
								>https://www.sakai-ipc.jp/</a
							>
						</dd>
						<dt class="col-sm-1">主催</dt>
						<dd class="col-sm-11">大阪ダーツオーガニゼイション</dd>
						<dt class="col-sm-1">協賛</dt>
						<dd class="col-sm-11">
							Heineken、いかるが乳業株式会社、G.S.D、CUE
							SOUL、千雅、有限会社FarEast
						</dd>
						<dt class="col-sm-1">協力店</dt>
						<dd class="col-sm-11">
							SELFISH、DUETT、BULL、Harrow's、LEAFLET、BALABUSHKA、Darts Bar
							FAMOUS、わんすもあー、Darts Bar JADE、KITCHEN ＆ BAR O2、Public
							Bar Stinger、Darts Bar Flame、Hugglife、J's、現場ar、Bar
							Eau-de-Vie、max OSAKA・心斎橋、宗右衛門町ハイボール うまいや
							、Darts House Reve、max OSAKA・梅田、HIDE OUT、お好み焼き
							だん、FarEastDarts
						</dd>
						<dt class="col-sm-1"></dt>
						<dd class="col-sm-11">
							<a
								class="btn btn-download"
								href="/pdf/2021/odo_tournament_2021.pdf"
								target="_blank"
								><i class="far fa-file-pdf mr-2"></i> 開催要項PDFダウンロード</a
							>
						</dd>
					</dl>
				</div>

				<div class="col-lg-8 mb-3">
					<h5 class="mb-2">エントリーリスト</h5>
					<div class="table-responsive mb-5">
						<table class="table table-striped">
							<thead class="thead-dark">
								<tr>
									<th scope="col" class="text-nowrap">#</th>
									<th scope="col" class="text-nowrap">エリア</th>
									<th scope="col" class="text-nowrap">名前</th>
									<th scope="col" class="text-nowrap">フリガナ</th>
									<th scope="col" class="text-nowrap">性別</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(player, index) in entries">
									<tr v-if="player.area != ''" :key="'rank' + index">
										<td class="text-nowrap">{{ index + 1 }}</td>
										<td class="text-nowrap">{{ player.area }}</td>
										<td class="text-nowrap score">{{ player.name }}</td>
										<td class="text-nowrap score">{{ player.kana }}</td>
										<td class="text-nowrap score">{{ player.sex }}</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<LightBox
				ref="lightbox"
				:media="media"
				:show-light-box="false"
				:show-caption="true"
			></LightBox>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import SubHeader from "@/components/common/SubHeader.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
//import VueLazyLoad from "vue-lazyload";
import LightBox from "vue-image-lightbox";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

Vue.use(Loading);

export default {
	name: "tournament2020",
	components: {
		SubHeader,
		LightBox,
	},
	data() {
		return {
			isLoading: true,
			entries: [],
			media: [
				{
					thumb: "/images/tournament/2021/result/mens_singles_winner.jpg",
					src: "/images/tournament/2021/result/mens_singles_winner.jpg",
					caption: "西本 陽一",
				},
				{
					thumb: "/images/tournament/2021/result/mens_singles_2nd.jpg",
					src: "/images/tournament/2021/result/mens_singles_2nd.jpg",
					caption: "石井 庸介",
				},
				{
					thumb: "/images/tournament/2021/result/mens_singles_3rd.jpg",
					src: "/images/tournament/2021/result/mens_singles_3rd.jpg",
					caption: "西巻 竜太",
				},

				{
					thumb: "/images/tournament/2021/result/ladies_singles_winner.jpg",
					src: "/images/tournament/2021/result/ladies_singles_winner.jpg",
					caption: "宮野 麻衣",
				},
				{
					thumb: "/images/tournament/2021/result/ladies_singles_2nd.jpg",
					src: "/images/tournament/2021/result/ladies_singles_2nd.jpg",
					caption: "青木 まゆ",
				},
				{
					thumb: "/images/tournament/2021/result/ladies_singles_3rd.jpg",
					src: "/images/tournament/2021/result/ladies_singles_3rd.jpg",
					caption: "安田 久美",
				},

				{
					thumb: "/images/tournament/2021/result/open_doubles_winner.jpg",
					src: "/images/tournament/2021/result/open_doubles_winner.jpg",
					caption: "磯和 勇希（大阪）・杉山 裕貴（一般）",
				},
				{
					thumb: "/images/tournament/2021/result/open_doubles_2nd.jpg",
					src: "/images/tournament/2021/result/open_doubles_2nd.jpg",
					caption: "谷田 孝夫（大阪）・高山 得溶（大阪）",
				},
				{
					thumb: "/images/tournament/2021/result/open_doubles_3rd.jpg",
					src: "/images/tournament/2021/result/open_doubles_3rd.jpg",
					caption: "谷田 尚嗣（大阪）・岩谷 由人（大阪）",
				},
			],
		};
	},
	mounted: function () {
		//this.getData();
	},
	methods: {
		getData: function () {
			this.isLoading = true;
			let loader = this.$loading.show({
				// Optional parameters
				container: this.fullPage ? null : this.$refs.formContainer,
				canCancel: false,
				color: this.$store.state.primary_color,
				backgroundColor: "#666",
			});
			let params = {};
			this.axios
				.get(
					"https://script.googleusercontent.com/macros/echo?user_content_key=ec4K8CAQZLa8tY9dIj5c1Da1zO78G19pyCP6PcoUWRTrfLi-M-NoZHina9oZtnHLjiGR1jV-gdsRanVNPMX6803VVHK7Crq0m5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnGkbT-vg5h-5hwy8wwLUz05CBwM7rPE4h9EG62R2mLwGGwKMLZnN_U0WXAoyY-ZqLdCyxssqcfhVHuEHPKfVH00SQ_tuX0y72g&lib=MKBAK7L1POPuvRRhfOCW-zCdAS-c8Xh_R",
					{
						params: params,
					}
				)
				.then((res) => {
					//console.log("res:" + JSON.stringify(res.data));
					this.entries = res.data.total;
					// simulate AJAX
					setTimeout(() => {
						loader.hide();
						this.isLoading = false;
					}, 500);
				});
		},
		openGallery(index) {
			this.$refs.lightbox.showImage(index);
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
	font-size: 1.6rem;
	margin-bottom: 1rem;
}
h4 {
	border-bottom: solid 3px #333;
	padding-bottom: 5px;
	margin-bottom: 2rem;
	position: relative;
	&:before {
		content: "";
		width: 3rem;
		height: 3px;
		background-color: $primary-color;
		display: block;
		position: absolute;
		left: 0;
		bottom: -3px;
	}
}
a {
	text-decoration: underline;
}
.container {
	padding: 5rem 1rem;
	text-align: left;
}
.btn-download {
	font-size: 1rem;
	color: #333;
	border: none;
	margin-top: 1rem;
	background: $primary-color;
	text-decoration: none;
	cursor: pointer;
	&:hover {
		color: #333;
		background-color: $secondary-color;
	}
	&:active {
		color: #333;
		background-color: $secondary-color;
	}
}
.rank,
.rank_winner,
.rank_2nd,
.rank_3rd,
.name {
	color: #333;
}
.rank_winner {
	font-size: 2rem;
	::v-deep i,
	::v-deep svg {
		color: #dbb400;
	}
}
.rank_2nd {
	font-size: 1.4rem;
	::v-deep i,
	::v-deep svg {
		color: #9fa0a0;
	}
}
.rank_3rd {
	font-size: 1.4rem;
	::v-deep i,
	::v-deep svg {
		color: #c47022;
	}
}
i {
	margin-right: 0.6rem;
}
</style>
